import React, { useRef, useEffect } from 'react'
import Chart, { ChartData } from 'chart.js/auto'
import styled from 'styled-components'
import { GasUsedResponse } from '../../../types/API'

interface GasUsdChartProps {
  data: GasUsedResponse
}

const GasUsdChart: React.FC<GasUsdChartProps> = ({ data }) => {
  const lineData: Record<string, number> = {}
  let totalizer = 0

  for (const value of Object.values(data)) {
    for (const [date, { totalUsd }] of Object.entries(value)) {
      if (lineData[date]) {
        lineData[date] += totalUsd
      } else {
        lineData[date] = totalUsd
      }
      totalizer += totalUsd
    }
  }

  const processData = () => {
    let allDateLabels: string[] = []
    Object.values(data).forEach((dates) => {
      const currentDates = Object.keys(dates)
      allDateLabels = Array.from(new Set([...allDateLabels, ...currentDates]))
    })

    allDateLabels.sort()

    return { dateLabels: allDateLabels }
  }

  const { dateLabels } = processData()

  const chartData: ChartData<'line', number[], string> = {
    labels: dateLabels,
    datasets: [
      {
        type: 'line',
        fill: true,
        label: 'Total gas USD',
        yAxisID: 'tasks-y-axis',
        data: Object.values(lineData),
        borderColor: 'rgb(203,91,22)',
        backgroundColor: 'rgb(122,67,33)',
        pointBackgroundColor: 'rgb(203,91,22)',
        tension: 0.8,
        pointRadius: 7,
        pointHoverRadius: 10,
        pointHoverBackgroundColor: 'rgb(203,91,22)',
        pointHoverBorderColor: 'rgb(203,91,22)',
      },
    ],
  }

  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const chartRef = useRef<Chart | null>(null)

  const createChart = () => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d')
      if (ctx) {
        chartRef.current = new Chart(ctx, {
          type: 'bar',
          data: chartData,
          options: {
            responsive: true,
            scales: {
              'tasks-y-axis': {
                beginAtZero: true,
              },
            },
          },
        })
      }
    }
  }

  const destroyChart = () => {
    if (chartRef.current) {
      chartRef.current.destroy()
    }
  }

  useEffect(() => {
    createChart()

    return () => {
      destroyChart()
    }
  }, [data])

  return (
    <>
      <h1>Gas USD {totalizer > 0 && <Tot>Total: {totalizer.toFixed(2)} USD</Tot>}</h1>
      <div>
        <canvas ref={canvasRef} />
      </div>
    </>
  )
}

const Tot = styled.p`
  font-size: 14px;
  display: inline-flex;
  background: rgb(203, 91, 22);
  padding: 5px 10px;
  border-radius: 22px;
  margin-left: 18px;
`

export default GasUsdChart
